import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';

import SubscriptionForm from './Form';

// NOTE: not-in use
const NewSubscription = ({
	stripePublishableKey,
	plan,
	hst,
	currentSubscription,
	coupons,
	defaultPaymentMethod,
	scTrialAvailable,
	product,
	plans,
}) => {
	return (
		<StripeProvider apiKey={stripePublishableKey}>
			<div className="row">
				<div className="columns small-12 medium-8 medium-offset-2">
					<h1>Payment details</h1>
					<br />
					<Elements>
						<SubscriptionForm
							{...{
								plan,
								hst,
								currentSubscription,
								coupons,
								defaultPaymentMethod,
								scTrialAvailable,
								product,
								plans,
							}}
						/>
					</Elements>
				</div>
			</div>
		</StripeProvider>
	);
};

export default NewSubscription;
